import React, {useEffect, useState} from "react";
import { uniqueNamesGenerator, Config, colors, animals } from 'unique-names-generator';
import {UserType} from "../utils/types";
import {db, userDoc} from "../utils/firebase";
import { collection, addDoc, updateDoc, onSnapshot } from 'firebase/firestore';

export type UserContextProps = {
  user: UserType | undefined
};

export const UserContext = React.createContext<UserContextProps>({
  user: undefined
});

const nameConfig: Config = {
  dictionaries: [colors, animals],
  separator: ' ',
  style: 'capital',
  length: 2
}

const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [userId, setUserId] = useState<string | undefined>();
  const [user, setUser] = useState<UserType>();

  useEffect(() => {
    let userId = localStorage.getItem('Estitool.userId');

    if (userId) {
      setUserId(userId)
    } else {
      let userName = uniqueNamesGenerator(nameConfig);

      const createUser = async () => {
        try {
          const usersRef = collection(db, "users");
          const docRef = await addDoc(usersRef, { name: userName });
          await updateDoc(docRef, { id: docRef.id });
          localStorage.setItem('Estitool.userId', docRef.id);
          setUserId(docRef.id);
        } catch (error) {
          console.error("Error creating user:", error);
        }
      };
      
      createUser();
    }
  }, []);

  useEffect(() => {
    if(userId && user === undefined) {
      onSnapshot(userDoc(userId), doc => {
        const userData = doc.data() as UserType;
        setUser(userData);
      })
    }
  }, [userId, user]);

  return (
    <UserContext.Provider value={{ user }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;